import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import CalendarSyncCard from "@/components/CalendarSyncCard";

const Row = ({ title, hint, checked, onChange, testid }) => (
  <div className="flex items-center justify-between gap-6 py-4">
    <div>
      <div className="text-sm font-medium">{title}</div>
      <p className="text-xs text-muted-foreground mt-1">{hint}</p>
    </div>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testid} />
  </div>
);

export default function MyNotificationsDialog({ open, onOpenChange }) {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    if (open) api.get("/me/notifications").then((r) => setPrefs(r.data)).catch(() => {});
  }, [open]);

  const update = async (key, value) => {
    const next = { ...prefs, [key]: value };
    setPrefs(next);
    try {
      await api.put("/me/notifications", { sms_digest: next.sms_digest, sms_change_alerts: next.sms_change_alerts });
      toast.success("Notification preferences saved");
    } catch (e) {
      setPrefs(prefs);
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="my-notifications-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">My notifications</DialogTitle>
          <DialogDescription>
            Choose which text messages you get{prefs?.phone ? ` on ${prefs.phone}` : ""}.
          </DialogDescription>
        </DialogHeader>
        {prefs && (
          <div className="divide-y divide-border/60">
            <Row title="Evening job list" hint="A text at 6:00 PM with tomorrow's bookings and addresses."
              checked={prefs.sms_digest} onChange={(v) => update("sms_digest", v)} testid="my-notif-digest" />
            <Row title="Instant change alerts" hint="A text when you're added to, removed from, or a booking moves today or tomorrow."
              checked={prefs.sms_change_alerts} onChange={(v) => update("sms_change_alerts", v)} testid="my-notif-alerts" />
          </div>
        )}
        <div className="border-t border-border/60 pt-5"><CalendarSyncCard compact /></div>
      </DialogContent>
    </Dialog>
  );
}
